import { useQuery } from 'react-query';

import { useToasts } from '@savgroup-front-common/core/molecules/NotificationsProvider';
import { themeService } from '@/api';

const GetTheme = 'getTheme';

interface UseSellerThemeArgs {
  sellerId?: string;
}

const useSellerTheme = ({ sellerId }: UseSellerThemeArgs) => {
  const { pushErrors } = useToasts();

  const { data: theme } = useQuery(
    [
      GetTheme,
      {
        sellerId,
      },
    ],
    async () => {
      if (!sellerId) {
        return undefined;
      }

      const responseSeller = await themeService.getSellerTheme({ sellerId });

      if ('failure' in responseSeller) {
        const responseClient = await themeService.getClientTheme();

        if ('failure' in responseClient) {
          const responseDefault = await themeService.getDefaultTheme();

          if ('failure' in responseDefault) {
            pushErrors(responseDefault.errors);

            return undefined;
          }

          return responseDefault;
        }

        return responseClient;
      }

      return responseSeller;
    },
    {
      staleTime: Infinity,
      suspense: true,
    },
  );

  return {
    theme,
  };
};

export default useSellerTheme;
